import React, { useState, useEffect } from 'react';
import { Navbar, Nav } from 'react-bootstrap';
import './Admin.scss';
import { LinkItem } from 'components';
import { Route, Switch, useHistory, useLocation } from 'react-router-dom';
import Admins from './Admins/Admins';
import ServiceWorks from './ServiceWorks/ServiceWorks';
import TestsResults from './TestsResults/TestsResults';
import { useUser } from 'reducers';
import AssortmentGraphics from './AssortmentGraphics/AssortmentGraphics';
import CacheManagement from './CacheManagement/CacheManagement';
import Statistics from './Statistics/Statistics';
import News from './News/News';
import Postals from './Postals/Postals';
import { ADMIN_TABS } from './adminTabs';
import _ from 'lodash';
import OnlineOrdersManual from './OnlineOrdersManual';
import { useDevice } from 'lib/hooks/useDevice';

const adminTabComponents: Record<string, React.ComponentType> = {
    admins: Admins,
    'service-works': ServiceWorks,
    'test-results': TestsResults,
    'assortment-graphics': AssortmentGraphics,
    news: News,
    'cache-management': CacheManagement,
    statistics: Statistics,
    postals: Postals,
    'online-orders-manual': OnlineOrdersManual
};

const Admin = () => {
    const [activeKey, setActiveKey] = useState('admins');
    const location = useLocation();
    const { isMedium } = useDevice();
    const history = useHistory();
    const user = useUser();

    useEffect(() => {
        if (location.pathname === `${process.env.PUBLIC_URL}/admin`) {
            const firstAllowedTab = ADMIN_TABS.find((tab) => user?.permissions[tab.permissionKey]);

            if (firstAllowedTab) {
                history.replace(`${process.env.PUBLIC_URL}/admin/${firstAllowedTab.pathSuffix}`);
            }
        }

        const activeTab = ADMIN_TABS.find((tab) => (
            location.pathname.includes(`${process.env.PUBLIC_URL}/admin/${tab.pathSuffix}`)
        ));

        if (activeTab) {
            setActiveKey(activeTab.pathSuffix);
        }
    }, [history, location.pathname, user]);

    return (
        <>
            {(user?.permissions.canAccessAdminPanel && isMedium) && (
                <Navbar className='sub-navbar' expand='lg'>
                    <Nav
                        justify
                        variant='pills'
                        className='flex-grow-1 flex-shrink-1'
                        activeKey={activeKey}
                    >
                        {_.map(ADMIN_TABS, (tab) => (
                            user?.permissions[tab.permissionKey] && (
                                <LinkItem
                                    key={tab.pathSuffix}
                                    to={`${process.env.PUBLIC_URL}/admin/${tab.pathSuffix}`}
                                    eventKey={tab.pathSuffix}
                                >
                                    {tab.title}
                                </LinkItem>
                            )
                        ))}
                    </Nav>
                </Navbar>
            )}
            <Switch>
                {_.map(ADMIN_TABS, (tab) => {
                    const Component = adminTabComponents[tab.pathSuffix];

                    if (!Component) {
                        return null;
                    }

                    return (
                        <Route key={tab.pathSuffix} path={`${process.env.PUBLIC_URL}/admin/${tab.pathSuffix}`}>
                            {user?.permissions[tab.permissionKey] && <Component />}
                        </Route>
                    );
                })}
            </Switch>
        </>
    );
};

export default Admin;
